import { Container, Grid, Typography } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Dialog from "../../components/common/Dialog";
import DialogConfirm from "../../components/common/DialogConfirm";
import SubmitButton from "../../components/common/SubmitButton";
import TextFieldOutlined from "../../components/common/TextFieldOutlined";
import UserContext from "../../context/user-context";
import useActionEvent from "../../hooks/useActionEvent";
import { useStore } from "../../hooks/useStore";
import useTabs from "../../hooks/useTabs";
import { useTranslation } from "../../hooks/useTranslation";
import Vehicle from "../../passapp-sdk/vehicle";
import { setFindCompanion } from "../../redux/actions/dataAction";
import { tabClose } from "../../redux/actions/tabActions";
import Authorizations from "../../shared/Authorizations/Authorizations";
import Companions from "../../shared/Companions/Companions";
import DialogBlackList from "../../shared/DialogBlackList/DialogBlackList";
import EntrantDetail from "../../shared/EntrantDetail/EntrantDetail";
import EntryMethods from "../../shared/EntryMethods/EntryMethods";
import Observations from "../../shared/Observations/Observations";
import Providers from "../../shared/Providers/Providers";
import {
  setAceptUnknown,
  setUserChange,
  setVehicles,
} from "../../store/actions/userAction";
import { GuestType } from "../../store/types/userTypes";
import { RoutePaths } from "../../utils/Items";
import { CompanionTabIndex, EntrantTabIndex } from "../../utils/tabIndex";
import { useStyles } from "./PrincipalDetailStyles";
import useRegisterExit from "../../hooks/useRegisterExit";
import {UserState} from "../../passapp-sdk/types/userTypes";

type PrincipalDetailProps = {
  stateTunnel?: (user: UserState) => void;
};

//A cambio del Manual input es la vista
export const PrincipalDetail = ({ stateTunnel }: PrincipalDetailProps) => {
  const classes = useStyles();
  const globalDispatch = useDispatch();
  const { t, BundleKey } = useTranslation();
  const { authStore } = useStore();
  const { state, dispatch } = useContext(UserContext);
  const history = useHistory();
  const vehicle = new Vehicle();
  const { fetchPeopleInside } = useRegisterExit();
  const [openDialogBlackList, setOpenDialogBlackList] = useState(false);
  const { getErrorsFields, sendEvent, loadingApprove, loadingReject } =
    useActionEvent();
  const [openDialogReject, setOpenDialogReject] = useState(false);
  const [dialogError, setDialogError] = useState<{
    open: boolean;
    errors: string[];
  }>({
    open: false,
    errors: [],
  });
  const { onCloseTab } = useTabs();

  useEffect(() => {
    if (state.isBlackList) {
      setOpenDialogBlackList(true);
    }
  }, [state.isBlackList]);

  // Ingreso residencial usa findVehicles/selectVehicle desde el buscador: no se debe precargar
  // toda la flota de la persona. El egreso conserva la lista heredada porque ya conoce el vehículo
  // del evento de entrada y todavía depende de ese comportamiento.
  useEffect(() => {
    if (state.config?.eventType === "out" && state.id) {
      getVehicles();
    }
  }, [state.config?.eventType, state.id]);

  const onApprove = () => {
    const errors = getErrorsFields();
    if (errors) {
      setDialogError({ open: true, errors });
    } else {
      sendEvent(() => {
        globalDispatch(tabClose(state.indexTab));
        history.push(RoutePaths.SearchManualInput);
        fetchPeopleInside();
      });
    }
  };

  const onReject = () => {
    sendEvent(() => {
      globalDispatch(tabClose(state.indexTab));
      history.push(RoutePaths.SearchManualInput);
    }, true);
  };

  const getVehicles = () => {
    vehicle
      .getVehicles(authStore.token, state.id)
      .then((response: any) => {
        let vehicles: any[] = response.data;
        if (vehicles && vehicles.length > 0) {
          if (state.vehicles && state.vehicles.length > 0) {
            state.vehicles.forEach((itemState) => {
              if (
                !vehicles.some(
                  (itemResponse) => itemResponse.id === itemState.id,
                )
              ) {
                vehicles.push(itemState);
              }
            });
          }
          dispatch(setVehicles(vehicles));
        }
      })
      .catch((err) => {
        console.error(`Error: ${err}`);
      });
  };

  const isProvider = () => {
    let flag: boolean = false;
    state.authorizations?.map((item) => {
      if (item.mark && item.guestType === GuestType.provider) flag = true;
    });
    return flag;
  };

  const addCompanion = () => {
    const errors = getErrorsFields();
    if (errors) {
      setDialogError({ open: true, errors });
    } else {
      globalDispatch(setFindCompanion(state));
    }
  };

  const onRegisterExit = () => {
    const errors = getErrorsFields();
    if (errors) {
      setDialogError({ open: true, errors });
    } else {
      sendEvent(() => {
        globalDispatch(tabClose(state.indexTab));
        history.push(RoutePaths.RegisterExit);
        fetchPeopleInside();
      });
    }
  };

  const onEdit = () => {
    const errors = getErrorsFields();
    if (errors) {
      setDialogError({ open: true, errors });
    } else {
      if (stateTunnel) stateTunnel(state);
    }
  };

  const closeBlackListDialog = () => {
    setOpenDialogBlackList(false);
  };

  const closeUnknownDialog = () => {
    onCloseTab(state.indexTab);
  };

  const submitUnknownDialog = () => {
    dispatch(setAceptUnknown());
  };

  const changeField = (field: string, value: string) => {
    dispatch(setUserChange(field, value));
  };

  const closeErrorDialog = () => {
    setDialogError({ ...dialogError, open: false });
  };

  const openRejectDialog = () => {
    setOpenDialogReject(true);
  };

  const closeRejectDialog = () => {
    setOpenDialogReject(false);
  };

  return (
    <Container maxWidth="xl">
      {state.isBlackList ? (
        <DialogBlackList
          open={openDialogBlackList}
          onClose={closeBlackListDialog}
        />
      ) : state.isUnknown ? (
        <Dialog
          open={state.isUnknown}
          onClose={closeUnknownDialog}
          onSubmit={submitUnknownDialog}
          ignoreClose
          title={t(BundleKey.DIALOG_FOREIGN_TITLE)}
          labelNo={t(BundleKey.ACTION_CANCEL)}
          labelYes={t(BundleKey.ACTION_ACCEPT)}
        >
          {t(BundleKey.DIALOG_FOREIGN_MESSAGE)}
        </Dialog>
      ) : (
        <Grid container direction="column">
          <Grid item xs={12}>
            <Grid
              container
              direction="column"
              justifyContent="space-between"
              alignItems="center"
              spacing={3}
            >
              <Grid item xs={12} style={{ width: "100vw" }}>
                <Grid container justifyContent="flex-start">
                  <Grid item>
                    <Typography variant="h5" style={{ margin: 10 }}>
                      {state.config?.companion
                        ? t(BundleKey.DETAIL_COMPATION_DETAIL_TITLE)
                        : state.config?.eventType === "in"
                        ? t(BundleKey.DETAIL_MAIN_TITLE)
                        : t(BundleKey.DETAIL_MAIN_TITLE_EXIT)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item className={classes.gridAuthorization}>
                <EntrantDetail />
              </Grid>
              <Grid item className={classes.gridAuthorization}>
                <Authorizations />
              </Grid>
              {isProvider() ? (
                <Grid item className={classes.gridAuthorization}>
                  <Providers />
                </Grid>
              ) : null}
              {!state.config?.companion ? (
                <Grid item className={classes.gridAuthorization}>
                  <EntryMethods />
                </Grid>
              ) : null}
              {(state.config?.eventType === "in" &&
                state.showCompanionSection &&
                !state.config?.companion) ||
              (state.config?.eventType === "out" &&
                state.companions?.length > 0 &&
                !state.config?.companion &&
                !state.config?.editMode) ? (
                <Grid item className={classes.gridAuthorization}>
                  <Companions />
                </Grid>
              ) : null}
              <Grid item className={classes.gridAuthorization}>
                <Observations />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              className={classes.buttonsContainer}
              spacing={2}
            >
              {state.config?.companion ? (
                <Grid item xs={12}>
                  <SubmitButton
                    color="primary"
                    size="large"
                    onClick={addCompanion}
                    tabIndex={CompanionTabIndex.addCompanion}
                  >
                    {t(BundleKey.DETAIL_COMPATION_ADD)}
                  </SubmitButton>
                </Grid>
              ) : state.config?.eventType === "in" ? (
                <>
                  <Grid item xs={4}>
                    <SubmitButton
                      color="secondary"
                      size="large"
                      onClick={openRejectDialog}
                      loading={loadingReject}
                      className={classes.buttonReject}
                      tabIndex={EntrantTabIndex.reject}
                    >
                      {t(BundleKey.ACTION_REJECT)}
                    </SubmitButton>
                  </Grid>
                  <Grid item xs={4}>
                    <SubmitButton
                      color="primary"
                      size="large"
                      onClick={onApprove}
                      loading={loadingApprove}
                      tabIndex={EntrantTabIndex.approve}
                    >
                      {t(BundleKey.ACTION_APPROVE)}
                    </SubmitButton>
                  </Grid>
                </>
              ) : state.config?.editMode ? (
                <Grid item xs={12} sm={4}>
                  <SubmitButton color="primary" size="large" onClick={onEdit}>
                    {t(BundleKey.ACTION_ACCEPT)}
                  </SubmitButton>
                </Grid>
              ) : (
                <Grid item xs={12} sm={4}>
                  <SubmitButton
                    color="primary"
                    size="large"
                    className={classes.buttonExit}
                    onClick={onRegisterExit}
                    loading={loadingApprove}
                    tabIndex={EntrantTabIndex.approve}
                  >
                    {t(BundleKey.ACTION_EXIT)}
                  </SubmitButton>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      )}
      <DialogConfirm
        openDialog={dialogError.open}
        handleConfirm={closeErrorDialog}
        handleClose={closeErrorDialog}
        message={
          <>
            {dialogError.errors.map((item, index) => (
              <span key={index}>{item}</span>
            ))}
          </>
        }
        title={t(BundleKey.DIALOG_FIELDMISSING_TITLE)}
        titleButtonOk={t(BundleKey.ACTION_ACCEPT)}
      />
      <Dialog
        open={openDialogReject}
        onClose={closeRejectDialog}
        onSubmit={onReject}
        labelNo={t(BundleKey.ACTION_CANCEL)}
        labelYes={t(BundleKey.ACTION_REJECT)}
        title={t(BundleKey.DIALOG_REJECTENTRY_MESSAGE)}
      >
        <TextFieldOutlined
          name="commentReject"
          type="text"
          value={state.commentReject}
          label=""
          onChange={(value) => changeField("commentReject", value)}
        />
      </Dialog>
    </Container>
  );
};
